/**
 * Find the filename from a Content-Disposition header.
 * Supports both "filename*" (RFC 5987) and classic "filename".
 */
export function parseFilenameFromContentDisposition(
  contentDisposition: string | undefined,
  defaultFilename: string
): string {
  if (!contentDisposition) return defaultFilename;

  const stripQuotes = (s: string): string => s.replace(/^['"]|['"]$/g, '').trim();

  // 1) filename* (RFC 5987) - ex: filename*=UTF-8''Fiche_client_42.xlsx
  const filenameStarMatch = contentDisposition.match(/filename\*\s*=\s*([^;]+)/i);
  if (filenameStarMatch && filenameStarMatch[1]) {
    let raw = stripQuotes(filenameStarMatch[1]);
    const starParts = raw.split("''");
    if (starParts.length > 1) {
      raw = starParts.slice(1).join("''");
    }
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }

  // 2) filename - ex: filename="Fiche_client_42.xlsx"
  const filenameMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i);
  if (filenameMatch && filenameMatch[1]) {
    return stripQuotes(filenameMatch[1]);
  }

  return defaultFilename;
}

/**
 * Trigger a browser download for the given blob data.
 */
export function downloadBlob(data: BlobPart, filename: string): void {
  const blob: Blob = new Blob([data]);
  const url: string = window.URL.createObjectURL(blob);
  const link: HTMLAnchorElement = document.createElement('a');

  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
